import React from "react";

const Fuel = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2 14.6693H10M2.66667 6.0026H9.33333M9.33333 14.6693V2.66927C9.33333 2.31565 9.19286 1.97651 8.94281 1.72646C8.69276 1.47641 8.35362 1.33594 8 1.33594H4C3.64638 1.33594 3.30724 1.47641 3.05719 1.72646C2.80714 1.97651 2.66667 2.31565 2.66667 2.66927V14.6693M9.33333 8.66927H10.6667C11.0203 8.66927 11.3594 8.80975 11.6095 9.0598C11.8595 9.30984 12 9.64898 12 10.0026V11.3359C12 11.6896 12.1405 12.0287 12.3905 12.2787C12.6406 12.5288 12.9797 12.6693 13.3333 12.6693C13.687 12.6693 14.0261 12.5288 14.2761 12.2787C14.5262 12.0287 14.6667 11.6896 14.6667 11.3359V6.55594C14.6668 6.38 14.6321 6.20577 14.5646 6.04329C14.4971 5.88082 14.3981 5.73331 14.2733 5.60927L12 3.33594" stroke="#252525" stroke-linecap="round" stroke-linejoin="round"/>
        </svg> 
    );
}

export default Fuel
